if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.resizeZoom = this.resizeZoom.bind(this);
      }

      hide() {
        window.removeEventListener('resize', this.resizeZoom);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        window.addEventListener('resize', this.resizeZoom);
      }

      resizeZoom() {
        const activeMedia = this.querySelector('.product-media-modal__content > .active');
        if (!activeMedia || activeMedia.tagName !== 'IMG') return;
        const source = this.openedBy.closest('modal-opener')?.querySelector('img');
        if (!source) return;
        const bounds = source.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        const ratio = source.naturalWidth / source.naturalHeight;
        const contained = getComputedStyle(source).objectFit === 'contain';
        const width = contained && ratio ? Math.min(bounds.width, bounds.height * ratio) : bounds.width;
        activeMedia.style.setProperty('width', width * 1.5 + 'px', 'important');
        activeMedia.style.setProperty('max-width', 'none', 'important');
        activeMedia.style.setProperty('height', 'auto', 'important');
        activeMedia.style.setProperty('max-height', 'none', 'important');
        activeMedia.style.setProperty('margin', '0 auto', 'important');
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const container = this.querySelector('[role="document"]');
        const media = Array.from(container.children).filter((element) => element.hasAttribute('data-media-id'));
        const activeMedia = media.find((element) => element.getAttribute('data-media-id') === mediaId);
        if (!activeMedia) return;
        media.forEach((element) => {
          const active = element === activeMedia;
          element.classList.toggle('active', active);
          element.hidden = !active;
          element.style.setProperty('display', active ? 'block' : 'none', 'important');
        });
        this.resizeZoom();
        container.scrollTop = 0;
        container.scrollLeft = Math.max(0, (container.scrollWidth - container.clientWidth) / 2);
        const activeMediaTemplate = activeMedia.querySelector('template');
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaTemplate?.content.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
